<template>
  <Table :headers="['Plano de aula', 'Aulas Necessárias', 'Aulas Realizadas', 'Aulas Aprovadas']">
    <tr v-for="(quantAulas, plano) in cargaHoraria" :key="plano">
      <td>{{ plano }}</td>
      <td>{{ quantAulas.aulasNecessarias }}</td>
      <td>{{ quantAulas.aulasRealizadas }}</td>
      <td>{{ quantAulas.aulasAprovadas }}</td>
    </tr>
  </Table>
</template>

<script>
import Table from '../core/Table'

export default {
  name: 'carga-horaria-pratica-table',
  components: {
    Table,
  },
  props: {
    cargaHoraria: {
      type: Object,
      required: true,
    }
  },
}
</script>
